<template>
	<div
		class="search bg-white pb-55"
		:class="{
			'pt-55': !hide_breadcrumb,
			offers: offers_checker,
			floors_page: $store.state.main.selected_menu.configs.includes('map'),
			border_bottom:
				$store.state.main.selected_menu.configs.includes('map') ||
				$store.state.main.selected_menu.configs.includes('shops'),
		}"
	>
		<div
			class="search__offers-filters container events-none"
			v-if="offers_checker"
			v-click-outside="hide"
		>
			<div class="search__offers-filters--row flex al-center events-all">
				<span
					class="bold f-16 mr-10 f-white uppercase pointer"
					@click="offers_filter_dropdown = !offers_filter_dropdown"
					>{{ $fn.tr('ფილტრი') }}</span
				>
				<svg
					@click="offers_filter_dropdown = !offers_filter_dropdown"
					xmlns="http://www.w3.org/2000/svg"
					width="10"
					height="7.857"
					viewBox="0 0 10 7.857"
				>
					<path
						id="Icon_material-play-arrow"
						data-name="Icon material-play-arrow"
						d="M19.857,7.5v10L12,12.5Z"
						transform="translate(-7.5 19.857) rotate(-90)"
						fill="#fff"
					/>
				</svg>
			</div>

			<transition name="offers-filter-dropdown">
				<div
					class="
            search__offers-filters--dropdown
            events-all
            flex
            column
            mt-13
            pt-20
            pr-20
            pl-20
            pb-7
            bg-white
          "
					v-if="offers_filter_dropdown"
				>
					<h2
						class="bold font-13 pointer mb-13 events-all"
						:class="{ active: offer_tag_val == item.id }"
						v-for="(item, idx) in offer_categories"
						:key="idx"
						@click="offer_tag_val = item.id"
					>
						{{ _.get(item, 'title') }}
					</h2>
				</div>
			</transition>
		</div>
		<BreadCrumb v-if="hide_breadcrumb" />
		<div class="search__inner container">
			<div class="search__input_wrapper">
				<el-input :placeholder="$fn.tr('ძიება')" v-model="search_val"></el-input>
				<SvgComponents :name="'search_icon'" />
			</div>

			<div
				class="search__selector_wrapper grid pt-55"
				v-if="
					categories && $store.state.main.selected_menu.configs.includes('show_search_selectors')
				"
			>
				<el-select
					v-model="value"
					:placeholder="$fn.tr('All Categories')"
					:popper-append-to-body="false"
				>
					<el-option
						v-for="item in categories"
						:key="_.get(item, 'id')"
						:label="_.get(item, 'title')"
						:value="_.get(item, 'id')"
					>
						<span>{{ _.get(item, 'title') }}</span>
					</el-option>
				</el-select>

				<el-select
					v-model="value2"
					:placeholder="$fn.tr('ქვეკატეგორიები')"
					:disabled="value ? false : true"
					:popper-append-to-body="false"
					:no-data-text="$fn.tr('ქვეკატეგორიები ცარიელია')"
				>
					<el-option
						v-for="item in sub_categories"
						:key="_.get(item, 'id')"
						:label="_.get(item, 'title')"
						:value="_.get(item, 'id')"
					>
					</el-option>
				</el-select>
			</div>

			<div
				class="search__menu_selector flex between"
				v-if="$store.state.main.selected_menu.configs.includes('show_link_toggler')"
			>
				<div class="search__menu_selector--left-col al-end flex">
					<template v-for="(item, index) in menus">
						<router-link
							class="search__menu_selector--cat"
							:key="index"
							:to="_.get(item, 'full_url')"
							v-if="!_.get(item, 'redirect_url')"
							:class="{
								active: _.get(item, 'id') == $store.state.main.selected_menu.id,
							}"
						>
							<h2
								class="font-16 pangram-black f-black uppercase"
								v-html="
									_.get($store.state.main, 'locale') == 'ge'
										? _.get(item, 'titles.ge.title')
										: _.get(item, 'titles.en.title')
								"
							></h2>
						</router-link>
						<a
							class="search__menu_selector--cat"
							:key="index"
							:href="_.get(item, 'full_url')"
							:target="_.get(item, 'url_target') == '_blank' ? '_blank' : '_self'"
							v-else
							:class="{
								active: _.get(item, 'id') == $store.state.main.selected_menu.id,
							}"
						>
							<h2
								class="font-16 pangram-black f-black uppercase"
								v-html="
									_.get($store.state.main, 'locale') == 'ge'
										? _.get(item, 'titles.ge.title')
										: _.get(item, 'titles.en.title')
								"
							></h2>
						</a>
					</template>
				</div>
				<div
					class="search__menu_selector--right-col flex"
					v-if="!$store.state.main.selected_menu.configs.includes('map')"
				>
					<el-checkbox v-model="shop_suggestions"
						><span class="f-13 bold">{{ $fn.tr('მაღაზიები შემოთავაზებებით') }}</span></el-checkbox
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SvgComponents from '@/components/SvgComponents';
import BreadCrumb from './BreadCrumb';
import fn from '@/helpers/func';
export default {
	components: { SvgComponents, BreadCrumb },
	props: ['hideDrodowns'],
	data() {
		return {
			shop_suggestions: false,
			search_val: '',
			value: '',
			value2: '',
			send_req: true,
			offers_filter_dropdown: false,
			offer_tag_val: '',
			first_loaded: false,
		};
	},
	beforeMount() {},
	mounted() {
		if (this.$route.path.includes('singleview')) {
		}
	},
	beforeDestroy() {
		this.first_loaded = false;
	},

	computed: {
		hide_breadcrumb() {
			// if (this.$store.state.main.selected_menu.configs.includes("shops")) {
			//   return true;
			// } else if (this.$store.state.main.selected_menu.configs.includes("map")) {
			//   return true;
			// } else {
			//   return false;
			// }
			if (this.$store.state.main.selected_menu.configs.includes('offers')) {
				return false;
			} else if (this.$store.state.main.selected_menu.configs.includes('news')) {
				return false;
			} else {
				return true;
			}
		},
		offers_checker() {
			return this.$store.state.main.selected_menu.configs.includes('offers');
		},
		news_checker() {
			return this.$store.state.main.selected_menu.configs.includes('news');
		},
		premium_checker() {
			return this.$store.state.main.selected_menu.configs.includes('premium_space');
		},
		contentData() {
			return this.$store.state.main.list_content_data;
		},
		main_type() {
			return this.$store.state.main.store_type;
		},
		main_project() {
			let proj = this.$route.params.path1;
			return this.$store.state.main.indx.terms.project.filter((cat) => cat.slug == proj)[0].id;
		},
		offer_categories() {
			let arr = [
					{
						title: this.$fn.tr('All'),
						id: 0,
					},
				],
				_arr;

			_arr = this.$store.state.main.indx.terms.store_labels;
			return arr.concat(_arr);
		},
		categories() {
			let arr = [
					{
						title: this.$fn.tr('All Categories'),
						id: 0,
					},
				],
				_arr;

			_arr = this.$store.state.main.indx.terms.store_categories.filter(
				(cat) =>
					cat.pid == 0 &&
					cat.store_type == this.main_type[0] &&
					cat.project &&
					cat.project.includes(this.main_project.toString())
			);
			return arr.concat(_arr);
		},
		sub_categories() {
			return this.$store.state.main.indx.terms.store_categories.filter(
				(cat) => cat.pid == this.value
			);
		},
		menus() {
			let _menus = [],
				map;
			let menus =
				this.$route.params.path1 == 'saburtalo'
					? this.$store.state.main.indx.menus.filter((m) =>
							m.configs.includes('search_main_type_saburtalo')
					  )
					: this.$store.state.main.indx.menus.filter((m) =>
							m.configs.includes('search_main_type_gldani')
					  );
			map = menus.filter((m) => m.configs.includes('map'))[0];
			_menus = _menus.concat(menus.filter((m) => m.configs.includes('shops'))[0]);
			_menus.push(map);
			_menus = _menus.concat(
				menus.filter((m) => !m.configs.includes('map') && !m.configs.includes('shops'))
			);

			return _menus;
		},
		per_page_count() {
			return this.$store.state.main.per_page;
		},
		unic_id() {
			return this.$store.state.main.unique_id;
		},
		current_content() {
			return this.$store.state.main.current_content;
		},
		store_category() {
			return this.$store.state.main.store_category;
		},
	},
	methods: {
		async search(key_words) {
			let params;
			if (this.offers_checker) {
				params = {
					id: _.get(this.$store.state.main.selected_menu, 'id'),
					componentUnicId: this.unic_id,
					searchText: key_words,
					taxonomies: {
						project: this.contentData.conf?.taxonomies?.project,
						store_labels: [this.offer_tag_val],
					},
					perPage: this.per_page_count,
					pageNumber: this.$route.query.page || 1,
				};
			} else if (this.premium_checker) {
				let prem_label = this.$store.state.main.indx.terms.store_labels.filter(
					(lab) => lab.premium_tag && lab.premium_tag[0] == 'yes'
				)[0].id;
				params = {
					id: _.get(this.$store.state.main.selected_menu, 'id'),
					componentUnicId: this.unic_id,
					searchText: key_words,
					taxonomies: {
						project: this.contentData.conf?.taxonomies?.project,
						store_types: this.contentData?.conf?.taxonomies?.store_types,
						store_categories: [!this.value2 ? this.value : this.value2],
						store_labels: [prem_label],
					},
					perPage: this.per_page_count,
					pageNumber: this.$route.query.page || 1,

					relations: this.shop_suggestions ? ['offers'] : '',
				};
			} else if (this.news_checker) {
				params = {
					id: _.get(this.$store.state.main.selected_menu, 'id'),
					componentUnicId: this.unic_id,
					searchText: key_words,
					taxonomies: {
						project: this.contentData.conf?.taxonomies?.project,
					},
					perPage: this.per_page_count,
					pageNumber: this.$route.query.page || 1,
				};
			} else {
				params = {
					id: _.get(this.$store.state.main.selected_menu, 'id'),
					componentUnicId: this.unic_id,
					searchText: key_words,
					taxonomies: {
						project: this.contentData.conf?.taxonomies?.project,
						store_types: this.contentData?.conf?.taxonomies?.store_types,
						store_categories: [!this.value2 ? this.value : this.value2],
					},
					perPage: this.per_page_count,
					pageNumber: this.$route.query.page || 1,

					relations: this.shop_suggestions ? ['offers'] : '',
				};
			}

			let res = await fn.postData('main/getDataList', params);
			this.$store.commit('main/setState', {
				key: 'search_list',
				val: res,
			});
		},

		set_link(id, subcat_id) {
			let _url = {
				path: '',
				query: { cat_id: id, item_type: subcat_id ? subcat_id : 0, page: 1 },
			};
			if (this.first_loaded) {
				this.$router.push(_url);
			}
		},

		hide() {
			this.offers_filter_dropdown = false;
		},
	},
	watch: {
		contentData: {
			immediate: true,
			deep: true,
			handler(ns) {
				console.log(ns);
			},
		},
		offer_tag_val(ns) {
			this.$store.commit('main/setState', {
				key: 'offer_tag_val',
				val: ns,
			});
			this.search(this.search_val);
		},
		value(ns, os) {
			if (this.value2 && this.first_loaded) {
				this.value2 = '';
			}

			// if (os) {
			this.set_link(ns, this.value2);

			// }
			this.search(this.search_val);
			this.$store.commit('main/setState', {
				key: 'search_val',
				val: ns,
			});
		},
		value2(ns, os) {
			this.search(this.search_val);
			if (ns) {
				this.set_link(this.value, ns);
			}
			if (ns) {
				this.$store.commit('main/setState', {
					key: 'search_val',
					val: ns,
				});
			}
		},
		search_val(ns, os) {
			if (ns.length > 2) {
				if (this.send_req) {
					this.search(ns);
				}
				this.$store.commit('main/setState', {
					key: 'search_typed',
					val: ns,
				});
			} else if (ns.length == 0) {
				this.search('');

				this.$store.commit('main/setState', {
					key: 'search_typed',
					val: '',
				});
			}
		},
		$route(to, from) {
			if (!to.query.cat_id && !this.news_checker && !this.offers_checker) {
				this.send_req = false;
				this.search_val = '';
				this.value = '';
				this.value2 = '';
				setTimeout(() => {
					this.send_req = true;
				}, 10);
			}

			if (to.query.cat_id && to.query.item_type == 0) {
				this.first_loaded = false;
				this.value = parseInt(to.query.cat_id);
				this.value2 = '';

				setTimeout(() => {
					this.first_loaded = true;
				}, 200);
			} else if (to.query.cat_id && to.query.item_type !== 0) {
				this.first_loaded = false;
				this.value = parseInt(to.query.cat_id);
				this.value2 = parseInt(to.query.item_type);
				setTimeout(() => {
					this.first_loaded = true;
				}, 200);
			}
		},
		shop_suggestions(ns) {
			this.search(this.search_val);
			this.$store.commit('main/setState', {
				key: 'shop_suggestions',
				val: ns,
			});
		},

		current_content: {
			immediate: true,
			handler(ns) {
				setTimeout(() => {
					let _type = this.$route.query.item_type,
						cat_id = this.$route.query.cat_id;
					let _terms = this.store_category[0];
					if (_type && cat_id) {
						if (_type == 0) {
							this.value = parseInt(cat_id);
						} else {
							this.value = parseInt(cat_id);
							this.value2 = parseInt(_type);
						}
					} else if (_terms) {
						this.value = _terms;
					}
				}, 500);
				setTimeout(() => {
					this.first_loaded = true;
				}, 700);
			},
		},
	},
};
</script>
<style lang="scss">
.search {
	.search__menu_selector h2 {
		position: relative;
		sup {
			font-family: 'Hm-Pangram-black';
			font-size: 10px;
		}
	}
}
</style>
<style lang="scss">
.offers-filter-dropdown {
	&-enter {
		opacity: 0;
		transform: translateY(20%);
		transition: ease-out 0.4s;
	}

	&-enter-to {
		opacity: 1;
		transform: translateY(0);
		transition: ease-out 0.4s;
	}
	&-leave {
		opacity: 1;
		transform: translateY(0);

		transition: ease-in-out 0.4s;
	}
	&-leave-to {
		opacity: 0;
		transition: ease-in-out 0.4s;
		transform: translateY(20%);
	}
}
.search.border_bottom {
	&:after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 2px;
		transition: 0.4s;
		background-image: linear-gradient(
			to right,
			#40adec 0%,
			#426ab3 20%,
			#3269e5 30%,
			#ffcb05 40%,
			#ffc900 50%,
			#ffc900 50%,
			#e11f26 60%,
			#e50b09 100%
		);
	}
}
.search {
	position: relative;

	transition: 0.4s;

	&.offers {
		background-color: $dirtywhite;
		.search__input_wrapper .el-input__inner {
			background-color: $dirtywhite;
		}
	}
	&__offers-filters {
		position: absolute;
		top: -45px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 20;
		&--row {
			// justify-content: flex-end;
			width: fit-content;
			margin-left: auto;
		}
		&--dropdown {
			width: fit-content;
			margin-left: auto;

			box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.16);
			h2 {
				color: rgba(26, 26, 26, 0.6);
				transition: 0.4s;
				&.active {
					color: $black;
				}
				@include hover {
					color: $black;
				}
			}
		}
	}
	&__input_wrapper {
		position: relative;
		padding-bottom: 21px;
		border-bottom: 2px solid #f2f2f2;

		.el-input {
			&__inner {
				position: relative;
				height: 46px;
				padding-left: 0;
				font-size: 34px;
				// font-family: "Hm-Pangram-bold";
				font-family: 'Firago-Book';
				border-top: none;
				border-left: none;
				border-right: none;
				border-bottom: none;
				border-radius: 0;
				color: $black;
				&:focus {
					border-color: #f2f2f2;
				}
			}
		}
		svg {
			position: absolute;
			top: 12px;
			right: 31px;
			pointer-events: none;
			transition: 0.4s;
		}
	}
	&__selector_wrapper {
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 30px;
		.el-input {
			&__inner {
				border-radius: 0;
				border: #c9c9ca 2px solid;
				height: 60px;
				font-size: 13px;
				// font-family: "Hm-Pangram-bold";
				font-family: 'Firago-Book';
				&::placeholder {
					color: $black;
				}
			}
		}
		.el-icon-arrow-up:before {
			content: url('../../assets/imgs/arrow.svg');
		}
		.el-select .el-input .el-select__caret {
			transform: rotateZ(0);
		}
		.el-select .el-input .el-select__caret.is-reverse {
			transform: rotateZ(90deg);
		}
		.el-select .el-input.is-focus .el-input__inner,
		.el-select .el-input__inner:focus {
			border-color: $black;
		}
		.el-input__icon {
			width: auto;
			margin-right: 30px;
		}
	}
	&__menu_selector {
		padding-top: 56px;
		&--cat {
			position: relative;
			padding-bottom: 12px;
			&:not(:last-child) {
				margin-right: 40px;
			}
			h2 {
				transition: 0.4s;
			}
			@include hover {
				h2 {
					color: $red;
				}
			}
			&:after {
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 2px;
				border-radius: 10px;
				background-color: $black;
				transition: 0.4s;
				opacity: 0;
			}

			&.active {
				h2 {
					color: $red;
				}
				&:after {
					opacity: 1;
				}
			}
		}
	}
	&.floors_page {
		background-color: $darkblue;
		.search {
			&__menu_selector--cat {
				h2 {
					color: white;
				}
				@include hover {
					h2 {
						color: $blue;
					}
				}
				&:after {
					background-color: $blue;
				}
				&.active {
					h2 {
						color: $blue;
					}
					&:after {
						opacity: 1;
					}
				}
			}
			&__input_wrapper {
				.el-input {
					&__inner {
						color: white;
						background-color: transparent;
						border-color: #515559;
					}
				}
				svg {
					path {
						fill: white;
					}
				}
			}
		}
	}
	.el-popper[x-placement^='bottom'] {
		margin-top: 0;
	}
	.el-popper .popper__arrow,
	.el-popper .popper__arrow::after {
		display: none;
	}
	.el-select-dropdown__item.selected {
		color: $black;
	}
	.el-select-dropdown {
		border: 2px solid $black;
		border-top: none;
		border-radius: 0;
		will-change: transform;
	}
	@media (max-width: 1439px) {
		&.pb-55 {
			padding-bottom: 34px;
		}
		.breadcrumb {
			padding-bottom: 21px;
		}
		&__menu_selector {
			padding-top: 21px;
			padding-top: 21px;
		}
	}
	@media (max-width: 1000px) {
		padding-top: 34px !important;
		padding-bottom: 34px !important;
		&__menu_selector {
			padding-top: 34px;
		}

		// .search__input_wrapper
		&__menu_selector {
			padding-top: 34px;
		}
	}
	@include screen(tablet) {
		&__selector_wrapper {
			grid-column-gap: 15px;
		}
	}

	@include screen(mobile) {
		&__selector_wrapper {
			grid-column-gap: 0px;
			grid-row-gap: 15px;
			padding-top: 34px;
			grid-template-columns: 1fr;
			grid-template-rows: 1fr 1fr;
			.el-input__icon {
				margin-right: 20px;
			}
		}
		&__menu_selector {
			flex-direction: column;
			&--cat {
				margin-top: 40px;
			}
			&--left-col {
				margin-top: -40px;
				margin-bottom: 34px;
				padding-bottom: 34px;
				border-bottom: 2px solid #f2f2f2;
				overflow-x: auto;
				flex-wrap: wrap;
				&::-webkit-scrollbar {
					height: 1px;
					width: 1px;
					background: transparent;
				}
				&::-webkit-scrollbar-thumb {
					height: 1px;
					width: 1px;
					background: transparent;
				}
				&::-webkit-scrollbar-track {
					height: 1px;
					width: 1px;
					background: transparent;
				}
			}
		}
		&__input_wrapper {
			padding-bottom: 29px;
			.el-input__inner {
				height: 28px;
				font-size: 21px;
			}
			svg {
				top: 0;
				right: 31px;
			}
		}
	}
}
</style>
